var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      [
        _c(
          "div",
          { staticClass: "form-group" },
          [
            _c("c-switcher", {
              attrs: { label: "Семейное положение" },
              model: {
                value: _vm.form.familyStatus.show,
                callback: function ($$v) {
                  _vm.$set(_vm.form.familyStatus, "show", $$v)
                },
                expression: "form.familyStatus.show",
              },
            }),
          ],
          1
        ),
        _c("transition", { attrs: { name: "slide" } }, [
          _vm.form.familyStatus.show
            ? _c(
                "div",
                { staticClass: "params" },
                [
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("c-switcher", {
                        attrs: { type: "checkbox", label: "Обязательное" },
                        model: {
                          value: _vm.form.familyStatus.required,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.familyStatus, "required", $$v)
                          },
                          expression: "form.familyStatus.required",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("list-params", {
                    attrs: {
                      form: _vm.form.familyStatus,
                      "field-name": "Семейное положение",
                      "field-type": _vm.fieldType,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("editDictionary", "familyStatuses")
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "form-group" },
      [
        _c("c-switcher", {
          attrs: { label: "Есть дети" },
          model: {
            value: _vm.form.hasChildren,
            callback: function ($$v) {
              _vm.$set(_vm.form, "hasChildren", $$v)
            },
            expression: "form.hasChildren",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }